<div style="margin-bottom: 12px">
  <greco-community-agreement-details
    [agreement]="agreement"
    [communityId]="communityId"
    (updated)="updated.emit($event)"
  ></greco-community-agreement-details>
</div>
